import React, { FunctionComponent, ReactNode } from 'react';
import { Box, Divider as MuiDivider, Typography } from '@mui/material';

export const Divider: FunctionComponent = () => <MuiDivider sx={{ mb: 2 }} />;

export const PanelSection: FunctionComponent<{ title: string; children: ReactNode }> = (props) => (
  <Box sx={{ mb: 1 }}>
    <Typography sx={{ mb: 1 }}>{props.title}</Typography>

    <Box sx={{ ml: 1 }}>{props.children}</Box>
  </Box>
);
